const setReportList = data => ({
    type: "SET_REPORT_LIST",
    data
});
export const mutation = {
    setReportList,
};
